import { Component } from '@angular/core';
import { IProfile, IResponse } from '@interfaces/index';
import { AppService } from '@ui-components/services';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html'
})
export class DashboardComponent {

  profile: IProfile | null = null;

  constructor(
    protected _app_service: AppService
  ) {}

  ngOnInit() {
    this._app_service.getProfile().subscribe(
      (response: IResponse<IProfile>) => {
        this.profile = response.data;
      }
    )
  }

}
